import { isEmbeddedInIframe } from '@/shared/embed/is-embedded';

/**
 * Detects whether the app is running inside an iframe (e.g. embedded in cockpit).
 * When true, layout components should skip rendering navigation chrome (headers, sidebars, tabs).
 */
export function useIsEmbedded(): boolean {
    return isEmbeddedInIframe();
}
